export default __webpack_public_path__ + "static/ten-98cd508210be3156c9f94948c57b55c0.png";